<template>
  <div class="relative text-black mt-4">
    <label class="flex flex-row">
      <input type="checkbox" v-model="checked" @input="onChange" />
      <p class="ml-2">Toon alleen gesloten taken</p>
    </label>
  </div>
</template>
<script>
export default {
  name: "ShowFinishedTasks",

  data() {
    return {
      checked: false
    };
  },
  methods: {
    onChange() {
      this.$store.dispatch("update_search", {
        selected: !this.checked,
        filtername: "is_finished",
        routename: this.$router.currentRoute.name
      });
    }
  }
};
</script>
